import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react'

interface AccountAdminSiteMenuContextValue {
  registerOpenMenu: (fn: (() => void) | null) => void
  openMenu: () => void
  /** True when org admin screen registered an opener (hide trigger while loading / no access). */
  menuEnabled: boolean
}

const AccountAdminSiteMenuContext = createContext<AccountAdminSiteMenuContextValue | null>(null)

export function AccountAdminSiteMenuProvider({ children }: { children: React.ReactNode }) {
  const openerRef = useRef<(() => void) | null>(null)
  const [menuEnabled, setMenuEnabled] = useState(false)

  const registerOpenMenu = useCallback((fn: (() => void) | null) => {
    openerRef.current = fn
    setMenuEnabled(fn != null)
  }, [])

  const openMenu = useCallback(() => {
    openerRef.current?.()
  }, [])

  const value = useMemo(
    () => ({
      registerOpenMenu,
      openMenu,
      menuEnabled,
    }),
    [registerOpenMenu, openMenu, menuEnabled],
  )

  return (
    <AccountAdminSiteMenuContext.Provider value={value}>{children}</AccountAdminSiteMenuContext.Provider>
  )
}

export function useAccountAdminSiteMenuOptional(): AccountAdminSiteMenuContextValue | null {
  return useContext(AccountAdminSiteMenuContext)
}
